import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from '../../routing';
const PageTransition: React.FC<{ children: React.ReactNode }> = ({ children }) => { const location = useLocation(); useEffect(() => { window.scrollTo(0, 0); document.body.style.overflow = ''; }, [location.pathname]); return <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -18 }} transition={{ duration: .45 }}>{children}</motion.div>; };
export default PageTransition;
